import {UsersTable} from '../../user-management/users-list/table/UsersTable'

/** Same table as staff users; list is pre-filtered to ROLE_USER in ClientsList. */
export const ClientsTable = UsersTable
